//Units
import { PathRunnerUnit } from "Core/Components/PathRunner/PathRunnerUnit";
import { PathRunnerViewModel } from "Core/Components/PathRunner/Models/View/PathRunnerViewModel";
import enumerable from '../../Common/Decorators/EnumerableDecorator';

export interface IPathRunnerPin {
	Model: PathRunnerViewModel;
	Sizes: number[];
	Expanded: boolean;
	Place: string;
}

export class PathRunner {
	private static _instance: PathRunner;
	private static _initialized: boolean;

	private _entityToUnit: { [enityId: number]: PathRunnerUnit };
	private _pin: IPathRunnerPin;
	private _navigationClaimed: boolean;

	constructor() {
		if (PathRunner._initialized) {
			throw new Error("Path runner already initialized");
		}

		PathRunner._initialized = true;
		this._entityToUnit = {};
		this._pin = null;
		this._navigationClaimed = false;
	}

	ClaimNavigation(pin: IPathRunnerPin) {
		if (this._pin) {
			pin.Place = this._pin.Place;
		}

		this._pin = pin;
		this._navigationClaimed = true;
	}

	get Pin(): IPathRunnerPin {
		return this._pin;
	}

	UpdatePinnedSettings(expanded: boolean, sizes: number[]) {
		if (this._pin) {
			this._pin.Expanded = expanded;
			this._pin.Sizes = sizes;
		}
	}

	ConsumePin(): IPathRunnerPin {
		if (!this._navigationClaimed) {
			this._pin = null;
			return null;
		}

		this._navigationClaimed = false;

		return this._pin;
	}

	ClearPin() {
		this._pin = null;
		this._navigationClaimed = false;
	}

	static get Instance() {
		if (PathRunner._instance) {
			return PathRunner._instance;
		}

		PathRunner._instance = new PathRunner();

		return PathRunner._instance;
	}

    GetUnit(entityId: number, isSpecialScreenExist: boolean) {
        let unit = this._entityToUnit[entityId];

        if (!unit) {
            unit = new PathRunnerUnit(entityId, isSpecialScreenExist);
            this._entityToUnit[entityId] = unit;
		}

		return unit;
	}
}